import React from "react";
import MUIInfoIcon from "@mui/icons-material/Info";
import CustomTooltip from "../Tooltip/Tooltip";

export default function InfoIcon({ style, dataTip }) {
  return (
    <CustomTooltip text={dataTip}>
      <MUIInfoIcon
        style={{ color: "#fff", outline: "none", cursor: "pointer", ...style }}
      />
    </CustomTooltip>
  );
}
